// Preguntas frecuentes (§7.7): <details> nativos. Este JS opcional abre la pregunta enlazada con #id
// y publica faq_open (solo al abrir) para la analítica, sin datos personales.
function openFromHash() {
  const id = decodeURIComponent(location.hash.slice(1));
  const target = id && document.getElementById(id);
  if (target instanceof HTMLDetailsElement) {
    target.open = true;
    target.scrollIntoView({ block: 'start' });
  }
}

document.addEventListener('toggle', (event) => {
  const details = event.target;
  if (!(details instanceof HTMLDetailsElement) || !details.open || !details.dataset.faqId) return;
  window.Shopify?.analytics?.publish?.('pawly:faq_open', { question_id: details.dataset.faqId, location: details.dataset.location });
}, true);

window.addEventListener('hashchange', openFromHash);
openFromHash();
